<template>
  <div>
    <b-form-group id="password" :label="$t($getConst.pages.personalDetails.password)" label-for="password-input">
      <b-input-group size="lg">
        <b-form-input
          id="nav-password-input"
          :disabled="isLoading"
          :type="passwordInputType"
          v-model.trim="$v.form.password.$model"
          :class="{ 'is-invalid':$v.form.password.$error }"
          :placeholder="$t($getConst.pages.personalDetails.password)"
          size="lg"
          required
        ></b-form-input>
        <b-input-group-append is-text id="toggle-password">
          <a id="show-password-button" @click="onShowPassword">
            <i :class="this.passwordInputType === 'password' ? this.$getConst.icons.eyeSlash : this.$getConst.icons.eye"
               aria-hidden="true"></i>
          </a>
        </b-input-group-append>
      </b-input-group>
      <AppFormFeedback :errors="$v.form.password" />
      <b-form-invalid-feedback v-if="$v.form.password.required && !$v.form.password.valid"  :class="{ 'is-display':$v.form.password.required && !$v.form.password.valid }">
        {{$t(this.$getConst.pages.form.password_field_error)}}.
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group id="re-password" :label="$t($getConst.pages.personalDetails.re_password)"
                  label-for="re-password-input">
      <b-input-group size="lg">
        <b-form-input
          id="re-password-input"
          v-model="$v.form.rePassword.$model"
          :class="{'is-invalid': $v.form.rePassword.$error }"
          :disabled="isLoading"
          :placeholder="$t($getConst.pages.personalDetails.re_password)"
          :type="repasswordInputType"
          size="lg"
          required
        ></b-form-input>
        <b-input-group-append is-text id="toggle-password">
          <a id="show-password-button" @click="onShowRePassword">
            <i :class="this.repasswordInputType === 'password' ? this.$getConst.icons.eyeSlash : this.$getConst.icons.eye"
               aria-hidden="true"></i>
          </a>
        </b-input-group-append>
      </b-input-group>
      <AppFormFeedback :errors="$v.form.rePassword" />
    </b-form-group>
    <b-form-checkbox
      id="terms"
      v-model="$v.form.terms.$model"
      :disabled="isLoading"
      class="mb-2"
      :class="{ 'is-invalid': $v.form.terms.$error }"
      name="terms"
      :value="true"
      :unchecked-value="false"
    >
      {{this.$t(this.$getConst.pages.sign_up.accept_terms_and_privacy_text_before_links)}}
      <a
        role="button"
        class="btn-link"
        :class="{ 'text-danger': $v.form.terms.$error }"
        @click="goTo($getConst.routesNames.administration.termsAndConditions)"
      >
        {{this.$t(this.$getConst.pages.sign_up.terms_and_conditions_link_text)}}
      </a> &
      <a
        role="button"
        class="btn-link"
        :class="{ 'text-danger': $v.form.terms.$error }"
        @click="goTo($getConst.routesNames.administration.privacyPolicy)"
      >
        {{this.$t(this.$getConst.pages.sign_up.privacy_policy_link_text)}}.
      </a>.
    </b-form-checkbox>
  </div>
</template>

<script>
  import AppFormFeedback from "../../components/common/form/AppFormFeedback";
  import {required} from "vuelidate/lib/validators";
  import minLength from "vuelidate/lib/validators/minLength";
  import maxLength from "vuelidate/lib/validators/maxLength";
  import sameAs from "vuelidate/lib/validators/sameAs";

  export default {
    name: "StepThree",
    components: {AppFormFeedback},
    data() {
      return {
        isLoading: false,
        form: {
          password: null,
          rePassword: null,
          terms: false
        },
        showPassword: false,
        passwordInputType: "password",
        repasswordInputType: "password",
      }
    },
    validations: {
      form: {
        password: {
          required,
          valid: function (value) {
            const containsUppercase = /[A-Z]/.test(value)
            const containsLowercase = /[a-z]/.test(value)
            const containsNumber = /[0-9]/.test(value)
            const containsSpecial = /[@#$%^&*_!+=[\]{}|\\:',.?/`~"();<>-]/.test(value)
            return (containsUppercase && containsLowercase && containsNumber) || (containsUppercase && containsLowercase && containsSpecial)
              || (containsUppercase && containsSpecial && containsNumber) || (containsNumber && containsLowercase && containsSpecial)
          },
          minLength: minLength(8),
          maxLength: maxLength(256),
        },
        rePassword: {sameAs: sameAs('password')},
        terms: {
          valid() {
            return this.form.terms
          }
        }
      }
    },
    methods: {
      goTo(routeName) {
        let routeData = this.$router.resolve({name: routeName});
        window.open(routeData.href, '_blank');
      },
      onShowPassword() {
        if (this.passwordInputType === "password") {
          this.passwordInputType = "text";
        } else {
          this.passwordInputType = "password";
        }
      },
      onShowRePassword() {
        if (this.repasswordInputType === "password") {
          this.repasswordInputType = "text";
        } else {
          this.repasswordInputType = "password";
        }
      },
    },
    watch: {
      $v: {
        handler: function (val) {
          if (!val.$invalid) {
            this.$store.dispatch("signup/setThirdStep", this.form);
            this.$emit('can-continue', {value: true});
          } else {
            this.$emit('can-continue', {value: false});
          }
        },
        deep: true
      },
      clickedNext(val) {
        if (val === true) {
          this.$v.form.$touch();
        }
      }
    },
    mounted() {
      if (!this.$v.$invalid) {
        this.$store.dispatch("signup/setThirdStep", this.form.password, this.form.rePassword, this.form.terms);
        this.$emit('can-continue', {value: true});
      } else {
        this.$emit('can-continue', {value: false});
      }
    }
  }
</script>

<style scoped>
  #nav-password-input {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }  #re-password-input {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .is-display{
   display: block;
  }
</style>
